<template>
  <div class="home">
    <van-overlay :show="loading">
      <div class="load-wp">
        <van-loading
          size="38px"
          color="#69E09F"
        >加载中...</van-loading>
      </div>
    </van-overlay>
    <banner-cp
      :banner="cp_banner"
      v-if="cp_banner"
    ></banner-cp>
    <div
      class="currVersion"
      v-if="menuId==0"
    >
      当前版本：
      <span>{{currVersion}}</span>
      <i @click="resetGradeInfo">点击切换</i>
    </div>
    <div
      class="currVersion"
      v-else
    >
      当前年级：
      <span>{{currVersion}}</span>
      <i @click="resetGradeInfo">点击切换</i>
    </div>
    <ul class="navMenu">
      <li
        :class="{hover:menuId==0}"
        @click="setMenuId(0)"
      >
        <a>预习专区</a>
      </li>
      <li
        :class="{hover:menuId==1}"
        @click="setMenuId(1)"
      >
        <a>专项提高</a>
      </li>
      <li
        :class="{hover:menuId==2}"
        @click="setMenuId(2)"
      >
        <a>防疫专区</a>
      </li>
    </ul>
    <div
      class="navContent"
      v-show="menuId==0"
    >
      <van-tabs
        animated
        @change="changTab"
      >
        <van-tab
          v-for="(itm,idx) in params.editionSelectResult"
          :title="itm.subjectName"
          :name="itm.subjectId"
          :key="idx"
        >
          <ul
            class="unitList"
            v-for="(unit,index) in childrens"
            :key="index"
          >
            <h1 v-html="unit.name"></h1>
            <li
              v-for="(course,index1) in unit.childrens"
              :key="index1"
            >
              <div v-if="course.mark=='目标' && course.contentPos>-1">
                <div
                  class="target"
                  v-if="(course.contentPos>-1 && unitNo==-1) || (course.contentPos>-1 && unitNo>0 && index<unitNo)"
                  @click="goTarget(course.contentPos)"
                >
                  <i class="icoTarget"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  class="target"
                  v-else
                >
                  <i class="icoTarget colorGray"></i>
                  <span v-text="course.name"></span>
                </div>
              </div>
              <div v-if="course.mark=='复习'">
                <div
                  class="target"
                  v-if="(course.childrens && (course.childrens.length>0) && unitNo==-1) || (course.childrens && (course.childrens.length>0) && unitNo>0 && index<unitNo)"
                >
                  <i class="icoHistory"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  class="target"
                  @click="lockTips"
                  v-else
                >
                  <i class="icoHistory colorGray"></i>
                  <span v-text="course.name"></span>
                </div>
                <ul
                  v-if="(course.childrens && (course.childrens.length>0)>0 && unitNo==-1) || (course.childrens && (course.childrens.length>0) && unitNo>0 && index<unitNo)"
                >
                  <li
                    v-for="(lession,index2) in course.childrens"
                    :key="index2"
                  >
                    <div
                      v-if="lession.mark.indexOf('基础')!=-1"
                      class="hide"
                    >
                      <span v-text="lession.name"></span>
                      <i></i>
                    </div>
                    <div
                      v-else
                      @click="openClose($event)"
                      :class="{icoTg: true, hide: (course.childrens[0].mark.indexOf('基础')!=-1 && index2>1) || (course.childrens[0].mark.indexOf('基础')==-1 && index2>0)}"
                    >
                      <em>提高</em>
                      <span v-text="lession.name"></span>
                      <i></i>
                    </div>
                    <ul
                      v-if="lession.childrens && (lession.childrens.length>0)"
                      :class="{hide: lession.mark.indexOf('基础')==-1}"
                    >
                      <li
                        v-for="(book,index3) in lession.childrens"
                        :key="index3"
                        @click="goPlayVideo(book.videoCode,book.videoType,book.contentPos,unit.childrens)"
                      >
                        <i class="icoPlay"></i>
                        <span v-text="book.showName"></span>
                      </li>
                    </ul>
                  </li>
                  <div
                    class="moreUpVideo"
                    v-if="(course.childrens && (course.childrens[0].mark.indexOf('基础')!=-1) && course.childrens.length>2) || (course.childrens && (course.childrens[0].mark.indexOf('基础')==-1) && course.childrens.length>1)"
                    @click="openMore($event)"
                  >更多提高</div>
                </ul>
              </div>
              <div v-if="course.mark=='学'">
                <h1
                  v-if="(course.childrens && (course.childrens.length>0) && unitNo==-1) || (course.childrens && (course.childrens.length>0) && unitNo>0 && index<unitNo)"
                  v-html="course.name"
                ></h1>
                <h1
                  v-else
                  class="colorGray"
                  @click="lockTips"
                  v-html="course.name"
                ></h1>
                <ul
                  v-if="(course.childrens && (course.childrens.length>0) && unitNo==-1) || (course.childrens && (course.childrens.length>0) && unitNo>0 && index<unitNo)"
                >
                  <li
                    v-for="(lession,index2) in course.childrens"
                    :key="index2"
                  >
                    <div
                      v-if="lession.mark.indexOf('基础')!=-1"
                      class="hide"
                    >
                      <span v-text="lession.name"></span>
                      <i></i>
                    </div>
                    <div
                      v-else
                      @click="openClose($event)"
                      :class="{icoTg: true, hide: (course.childrens[0].mark.indexOf('基础')!=-1 && index2>1) || (course.childrens[0].mark.indexOf('基础')==-1 && index2>0), 'hide-new':(lession.mark.includes('练习') || lession.mark.includes('答案'))}"
                    >
                      <em>提高</em>
                      <span v-text="lession.name"></span>
                      <i></i>
                    </div>
                    <ul
                      v-if="lession.childrens && (lession.childrens.length>0)"
                      :class="{hide: lession.mark.indexOf('基础')==-1}"
                    >
                      <li
                        v-for="(book,index3) in lession.childrens"
                        :key="index3"
                        @click="goPlayVideo(book.videoCode,book.videoType,book.contentPos,unit.childrens)"
                      >
                        <i class="icoPlay"></i>
                        <span v-text="book.showName"></span>
                      </li>
                    </ul>
                  </li>
                  <div
                    class="moreUpVideo"
                    v-if="((course.childrens && (course.childrens[0].mark.indexOf('基础')!=-1) && course.childrens.length>2) || (course.childrens && (course.childrens[0].mark.indexOf('基础')==-1) && course.childrens.length>1)) && tempHandle(course.childrens)"
                    @click="openMore($event)"
                  >更多提高</div>
                </ul>
              </div>
              <div v-if="course.mark=='练习'">
                <div
                  v-if="(course.contentPos>-1 && unitNo==-1) || (course.contentPos>-1 && unitNo>0 && index<unitNo)"
                  class="test53"
                  @click="goExam(course.name,course.contentPos)"
                >
                  <i class="ico53"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  v-else
                  class="test53 colorGray"
                  @click="lockTips"
                >
                  <i class="ico53"></i>
                  <span v-text="course.name"></span>
                </div>
              </div>
            </li>
          </ul>
        </van-tab>
      </van-tabs>
    </div>
    <special
      v-if="menuId==1"
      :specialParams="specialParams"
      :lessonId="params.lessonId"
    ></special>
    <prevent-epidemic
      v-if="menuId==2"
      :preventEpidemicParams="specialParams"
      :lessonId="params.lessonId"
    ></prevent-epidemic>
      <askMore :show="showAskMore" @close="showAskMore = false"></askMore>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper';
import { baseUrl, cd_baseUrl } from '@/assets/js/api'
import special from '../components/Special';
import preventEpidemic from '../components/preventEpidemic';
import bannerCp from '@/components/common/Banner'
import askMore from "@/components/common/askMore";
var _timer = null;
export default {
    name: 'Home',
    components: {
        special,
        preventEpidemic,
        bannerCp,
        askMore
    },
    data () {
        return {
            loading: true,
            banner: '',
            phone: '',
            wxUrls: [],
            showAskMore: false,
            unitNo: -1,
            menuId: 0,
            currVersion: '',
            contentHost: '',
            params: {
                editionSelectResult: [{
                    subjectId: '1111',
                    subjectName: "语文",
                    editions: [{
                        editionId: 1,
                        editionName: "北师大版"
                    }]
                }],
                gradeSelectResult: {
                    gradeName: "二年级",
                    gradeId: "2"
                },
                eduSystemId: '2',//学制
                lessonId:''
            },
            childrens: [],
            contents: [],
            courseName: '',
            specialParams: {
                gradeId: 2,
                phaseId: 2,
                subjectMap: { "1": 2, "2": 2, "3": 32 },
                version: 2,
            }
        }
    },
    created () {

    },
    mounted () {
        this.params = paramsHelper.decode(this.$route.query.params);
        let { gradeSelectResult, editionSelectResult, eduSystemId, lessonId } = this.params
        this.currVersion = gradeSelectResult.gradeName + ' ' + editionSelectResult[0].editions[0].editionName+' ' +
            (editionSelectResult[0].editions[0].termActive ===1 ? '上册' : '下册');
        this.currText = this.currVersion;//保存一份
        Object.assign(this.specialParams, {
            gradeId: gradeSelectResult.gradeId,
            phaseId: this.getPhaseId(gradeSelectResult.gradeId, eduSystemId)
        })
        this.getCourseContent(gradeSelectResult.gradeId, eduSystemId, editionSelectResult[0].subjectId,
            editionSelectResult[0].editions[0].editionId, editionSelectResult[0].editions[0].termActive);
    },
    computed: {
        cp_banner () {
            return sessionStorage.getItem('banner')
        }
    },
    methods: {
        openClose: function (e) {
            $(e.currentTarget).toggleClass('hover');
            $(e.currentTarget).next('ul').toggle();
        },
        openMore: function (e) {
            $(e.currentTarget).toggleClass('hide');
            $(e.currentTarget).parent().find(".icoTg").removeClass("hide");
        },
        setMenuId (id) {
            let { gradeSelectResult, editionSelectResult, eduSystemId } = this.params;
            if (id === 0) {
                this.currVersion = this.currText
            } else {
                this.setCurrVersion(gradeSelectResult.gradeName)
            }
            this.menuId = id;
            Object.assign(this.specialParams, {
                gradeId: gradeSelectResult.gradeId,
                phaseId: this.getPhaseId(gradeSelectResult.gradeId, eduSystemId)
            })
        },
        setCurrVersion (gradeName, editionName = '', termActive) {
            this.currVersion = gradeName + ' ' + editionName + ' ' + (termActive ===1 ? '上册' : '下册');
        },
        resetGradeInfo () {
            this.$router.push({
                name: 'GradeSelect',
                query: { lessonId: this.params.lessonId || '' }
            })
        },
        changTab (name, title) {
            let { gradeSelectResult, editionSelectResult, eduSystemId } = this.params;
            let { editionName, editionId, termActive} = editionSelectResult.filter(itm => itm.subjectId === name)[0].editions[0];
            this.setCurrVersion(gradeSelectResult.gradeName, editionName, termActive)
            this.getCourseContent(gradeSelectResult.gradeId, eduSystemId, name, editionId, termActive)
        },
        goPlayVideo (videoId, videoType, pos, unitObj) {
            sessionStorage.c_unitObj = JSON.stringify(unitObj);
            this.$router.push({
                name: 'Video',
                query: { params: paramsHelper.encode({ videoId, videoType, pos, courseName: this.courseName }), lessonId: this.params.lessonId || '' }
            })
        },
        goTarget (pos) {
            this.$router.push({
                name: 'Target',
                query: { pos, lessonId: this.params.lessonId || '' }
            })
        },
        goExam (name, pos) {
            this.$router.push({
                name: 'Exam',
                query: { params: paramsHelper.encode({ name, pos }), lessonId: this.params.lessonId || '' }
            })
        },
        lockTips () {
            /*this.$Dialog.alert({
                confirmButtonText: '知道了',
                message: '进一步了解详情<br>请咨询教育顾问'
            }).then(() => {
                // on close
            });*/
            this.showAskMore = true;
        },
        getPhaseId (gradeId, eduSystemId) {
            var phaseId = 2;
            if (eduSystemId == 1) {//六三学制
                if (gradeId < 7) {
                    phaseId = 2;
                } else if (gradeId > 6 && gradeId < 10) {
                    phaseId = 3;
                } else { }
            } else {
                if (gradeId < 6) {
                    phaseId = 2;
                } else if (gradeId > 5 && gradeId < 10) {
                    phaseId = 3;
                } else { }
            }
            return phaseId;
        },
        getCourseContent (gradeId, eduSystemId, subjectId, editionId, termId) {
            var that = this;
            that.loading = true;
            this.$axios.get(baseUrl + '/ures/resource/prelearn/getContent', {
                params: {
                    gradeId: gradeId,
                    phaseId: that.getPhaseId(gradeId, eduSystemId),
                    subjectId: subjectId,
                    termId: termId,
                    editionId: editionId,
                    version: 2,
                    xuezhi: eduSystemId,	//1:六三  2:五四
                    id: 0,
                    dianziFlag: 1
                }
            }).then(function (res) {
              that.loading = false;
              let { msg, value } = res.data
              if (res && msg === 'success') {
                that.loading = false;
                let { contents, childrens, host, id, name } = value;
                Object.assign(that, {
                  contents,
                  childrens,
                  contentHost: host,
                  courseName: name
                });
                sessionStorage.setItem('c_contentContents', JSON.stringify(contents))//用于后续视频播放内容及单元目标数据等
                sessionStorage.setItem('c_host', host);
              } else {
                that.$toast(msg || '系统出错，请联系管理员');
              }
            }).catch(function (err) {
                that.loading = false;
                that.$toast(err.errmsg || err.data.errmsg);
            });
        },
        tempHandle (data) {
          let filterArr = data.filter((item) => {
            return !item.mark.includes('基础') && !item.mark.includes('答案') && !item.mark.includes('练习');
          });
          return filterArr.length > 1;
        }
    }
}
</script>

<style scope lang="less">
.home {
}
.hide-new{display: none;}
</style>
